<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="modalTitle"
  [nzFooter]="modalFooter"
  (nzOnCancel)="close()"
  [nzWidth]="900"
>
  <ng-template #modalTitle>
    <app-modal-title icon="snippets" title="Vista previa — Formato del Cliente" />
  </ng-template>

  <div *nzModalContent>
    <nz-spin [nzSpinning]="loading">

      <nz-steps [nzCurrent]="currentStep" nzSize="small" class="mb-4">
        <nz-step nzTitle="Datos Generales"></nz-step>
        <nz-step nzTitle="Condiciones"></nz-step>
        <nz-step nzTitle="Comisiones"></nz-step>
      </nz-steps>

      <!-- ════════════════════════════════════════════════════════════════ -->
      <!-- PASO 1: DATOS GENERALES                                           -->
      <!-- ════════════════════════════════════════════════════════════════ -->
      <div [hidden]="currentStep !== 0">

        <app-section-header title="Datos Generales del Cliente" />
        <table class="preview-table">
          <tbody>
            @for (row of datosGenerales; track row.label) {
              <tr>
                <th>{{ row.label }}</th>
                <td>{{ row.value }}</td>
              </tr>
            }
            <tr>
              <th>Regímenes Fiscales</th>
              <td>
                @if (regimenesLabels.length) {
                  @for (t of regimenesLabels; track t) {
                    <nz-tag>{{ t }}</nz-tag>
                  }
                } @else {
                  —
                }
              </td>
            </tr>
          </tbody>
        </table>

        <app-section-header title="Domicilio Fiscal del Cliente" />
        <table class="preview-table">
          <tbody>
            @for (row of domicilioFiscal; track row.label) {
              <tr>
                <th>{{ row.label }}</th>
                <td>{{ row.value }}</td>
              </tr>
            }
          </tbody>
        </table>

        <app-section-header title="Personal Responsable del Cliente" />
        <table class="preview-table">
          <tbody>
            @for (row of personalResponsable; track row.label) {
              <tr>
                <th>{{ row.label }}</th>
                <td>{{ row.value }}</td>
              </tr>
            }
          </tbody>
        </table>

        <app-section-header title="Descripción de Actividades" />
        <table class="preview-table">
          <tbody>
            <tr>
              <th>Fecha de Inicio</th>
              <td>{{ fechaInicio ? (fechaInicio | date:'dd/MM/yyyy') : '—' }}</td>
            </tr>
            <tr>
              <th>Descripción</th>
              <td class="preview-multiline">{{ descripcionActividades || '—' }}</td>
            </tr>
          </tbody>
        </table>

        <app-section-header title="Empresas Asignadas" />
        @if (empresasConConceptos.length) {
          <table class="preview-table">
            <thead>
              <tr>
                <th>Razón Social</th>
                <th>Conceptos</th>
              </tr>
            </thead>
            <tbody>
              @for (e of empresasConConceptos; track e.empresa) {
                <tr>
                  <td>{{ e.empresa }}</td>
                  <td>
                    @if (e.conceptos.length) {
                      @for (c of e.conceptos; track c) {
                        <nz-tag>{{ c }}</nz-tag>
                      }
                    } @else {
                      —
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <nz-alert nzType="info" nzShowIcon nzMessage="Sin empresas asignadas." class="mb-3" />
        }

      </div>

      <!-- ════════════════════════════════════════════════════════════════ -->
      <!-- PASO 2: CONDICIONES                                               -->
      <!-- ════════════════════════════════════════════════════════════════ -->
      <div [hidden]="currentStep !== 1">

        <app-section-header title="Condiciones Generales" />
        <table class="preview-table">
          <tbody>
            @for (row of condicionesGenerales; track row.label) {
              <tr>
                <th>{{ row.label }}</th>
                <td>{{ row.value }}</td>
              </tr>
            }
          </tbody>
        </table>

        <app-section-header title="Beneficios Adicionales" />
        <table class="preview-table">
          <tbody>
            <tr>
              <td>{{ beneficioAdicional || '—' }}</td>
            </tr>
          </tbody>
        </table>

        <app-section-header title="Observaciones y Comentarios" />
        <table class="preview-table">
          <tbody>
            <tr>
              <td class="preview-multiline">{{ observaciones || '—' }}</td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- ════════════════════════════════════════════════════════════════ -->
      <!-- PASO 3: COMISIONES                                                -->
      <!-- ════════════════════════════════════════════════════════════════ -->
      <div [hidden]="currentStep !== 2">

        <app-section-header title="Socio Vendedor (Broker) e Implant" />
        <table class="preview-table">
          <tbody>
            <tr>
              <th>Socio Vendedor</th>
              <td>{{ brokerLabel }}</td>
            </tr>
            <tr>
              <th>Plan Implant</th>
              <td>{{ implantLabel }}</td>
            </tr>
          </tbody>
        </table>

        <app-section-header title="Condiciones Internas" />
        <table class="preview-table">
          <tbody>
            <tr>
              <td class="preview-multiline">{{ condicionesInternas || '—' }}</td>
            </tr>
          </tbody>
        </table>

        <app-section-header title="Observaciones y Comentarios" />
        <table class="preview-table">
          <tbody>
            <tr>
              <td class="preview-multiline">{{ observacionesComisiones || '—' }}</td>
            </tr>
          </tbody>
        </table>

      </div>

    </nz-spin>
  </div>

  <ng-template #modalFooter>
    <div class="modal-footer">
      <button nz-button class="sinay-outline-reset" (click)="close()">Cerrar</button>
      @if (currentStep > 0) {
        <button nz-button class="sinay-outline-reset" (click)="prevStep()">Anterior</button>
      }
      @if (currentStep < totalSteps - 1) {
        <button nz-button class="btn-add" (click)="nextStep()">Siguiente</button>
      }
    </div>
  </ng-template>
</nz-modal>
